import {configureStore} from "@reduxjs/toolkit";
import authReducer from '../counter/authSlice'

export default configureStore({
    reducer:{
        auth:authReducer
    }
})